import { render } from "./VideoElementOperate.vue?vue&type=template&id=de35c070&scoped=true&ts=true"
import script from "./VideoElementOperate.vue?vue&type=script&lang=ts"
export * from "./VideoElementOperate.vue?vue&type=script&lang=ts"

import "./VideoElementOperate.vue?vue&type=style&index=0&id=de35c070&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de35c070"]])

export default __exports__